<div class="row">
  <div class="col-12 col-lg-4 offset-lg-4">
    <h1>Sign Out</h1>
    @if (errorMessage) {
      <p class="alert alert-danger">{{errorMessage}}</p>
    }
    @if (!errorMessage) {
      <p>You have successfully signed out of the application.</p>
    }
    @if (!errorMessage) {
      <p><a href="/identity/account/login">Sign Back In</a></p>
    }
  </div>
</div>
